// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation_navBar__li\\+yK {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: blue;
    height: 80px;
    padding-left: 20px;
    padding-right: 20px;
    background: #fff;
    box-shadow: 11.916px 23.833px 55.61px 0px rgba(0, 0, 0, 0.04);
}

.navigation_navItems__z96AC {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 40px;
    height: 100%;
    padding: 0;
    margin: 0;
}

.navigation_navItems__z96AC li {
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.36px;
    color: #ccc;
    transition: color 0.35s ease-in-out;
}

.navigation_navItems__z96AC li:hover {
    color: #5151f9;
}
`, "",{"version":3,"sources":["webpack://./src/_components/profile/navigation/navigation.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".navBar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: blue;\n    height: 80px;\n    padding-left: 20px;\n    padding-right: 20px;\n    background: #fff;\n    box-shadow: 11.916px 23.833px 55.61px 0px rgba(0, 0, 0, 0.04);\n}\n\n.navItems {\n    list-style: none;\n    display: flex;\n    align-items: center;\n    gap: 40px;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n}\n\n.navItems li {\n    cursor: pointer;\n    font-family: 'Poppins', sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: -0.36px;\n    color: #ccc;\n    transition: color 0.35s ease-in-out;\n}\n\n.navItems li:hover {\n    color: #5151f9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navBar": `navigation_navBar__li+yK`,
	"navItems": `navigation_navItems__z96AC`
};
export default ___CSS_LOADER_EXPORT___;
